// @ts-nocheck
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { ASSETS } from '../../../assets/assets';

@Component({
  selector: 'lbca-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  imports: [IconComponent],
})
export class PaginationComponent implements OnInit {
  readonly assets = inject(ASSETS);
  public fieldsLabels: any = {};
  public page = 1;
  public lastPage = 1;

  @Input()
  set actualPage(page: number) {
    if (page < 1) {
      this.lastPage;
    } else {
      if (typeof page === 'number') {
        this.page = page;
      }
    }
  }

  @Input()
  set maxPages(last: number) {
    if (last < 1) {
      this.lastPage = 1;
    } else {
      if (!isNaN(last)) {
        this.lastPage = last;
      }
    }
  }

  @Input() hideMaxPages = false;

  @Input() anchorLink!: string;

  @Output() selectedPage = new EventEmitter<number>();
  @Output() orientation = new EventEmitter<'next' | 'prev'>();

  public ngOnInit(): void {
    this.fieldsLabels = this.assets.labels.components.fields;
  }
  public goTo($event, pagination: 'next' | 'prev') {
    $event.stopPropagation();

    if (pagination === 'prev' && this.page === 1) return;
    if (pagination === 'next' && this.page === this.lastPage) return;

    pagination === 'prev' ? this.page-- : this.page++;

    this.orientation.emit(pagination);

    this.selectedPage.emit(this.page);
    if (this.anchorLink) this.scrollToElement(this.anchorLink);
  }

  scrollToElement(target): void {
    const element = document.getElementById(target);
    element?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }
}
